<script setup lang="ts">
import Views from '@/components/Views/Views.vue';
import ViewsContainer from '@/components/Views/ViewsContainer.vue';
import AdminTabs from '@/views/Tabs/AdminTabs.vue';
import { useStore } from '@/store';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import { format, fromUnixTime } from 'date-fns';
import axios from 'axios';

const router = useRouter();
const store = useStore();
const isMarvinRecruiter = computed(() => store.getters['user/isMarvinRecruiter']);
const collections = ref([]);
onMounted(async () => {
  if (!isMarvinRecruiter.value) {
    router.push('/');
  } else {
    await getCollections();
  }
});

async function getCollections() {
  try {
    const { data } = await axios.get(`${import.meta.env.VITE_TYPESENSE_URL || 'http://localhost:8108'}/collections`, {
      headers: {
        'X-TYPESENSE-API-KEY': import.meta.env.VITE_TYPESENSE_API_KEY || 'xyz',
      },
    });
    collections.value = data?.map(collection => ({
      name: collection.name,
      num_documents: collection.num_documents,
      created_at: collection.created_at,
    }));
  } catch (error) {
    console.error('Error fetching collections', error?.response);
  }
}
</script>

<template>
  <views class="admin-typesense">
    <admin-tabs></admin-tabs>
    <router-view></router-view>
    <views-container>
      <div class="flex-col gap-4">
        <div class="flex-row gap-2 items-center justify-between">
          <h1 class="text-xl font-bold">Typesense collections</h1>
        </div>
        <div class="flex-col gap-2" v-for="collection in collections" :key="collection.name">
          <div class="flex-row gap-2 bg-blue-100 p-2 rounded-md flex-col">
            <h2 class="text-lg font-bold">{{ collection.name }}</h2>
            <p class="text-sm">Nombre de documents: {{ collection.num_documents }}</p>
            <p class="text-sm">Créé le: {{ format(fromUnixTime(collection.created_at), 'dd/MM/yyyy HH:mm:ss') }}</p>
          </div>
        </div>
      </div>
    </views-container>
  </views>
</template>
